import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router';
import { ChatPage } from './index';

export interface ChatPageRoutingProps extends RouteComponentProps {}

export const ChatPageRouting = (props: ChatPageRoutingProps) => {
  return (
    <Switch>
      <Route path={`${props.match.path}/`} component={ChatPage} exact />
    </Switch>
  );
};

